import { writable } from 'svelte/store';
export const messagesToShow = writable([]);
export function addFloatingMessage(message) {
    messagesToShow.update(msgs => {
        const msgToAdd = Object.assign(Object.assign({}, message), { id: message.key !== undefined ? message.key : `${Date.now()}${Math.random()}` });
        // make sure there are no other messages with given id
        const newMessages = msgs.filter(msg => msg.id !== msgToAdd.id);
        console.log("filtered messages", newMessages);
        return [...newMessages, msgToAdd];
    });
}
export function removeFloatingMessage(message) {
    messagesToShow.update(msgs => {
        const filteredMsgs = msgs.filter(msg => msg.id !== message.id);
        return [...filteredMsgs];
    });
}
